<template>

  <section class="dp-layout">
    <!-- 
    <section class="dp-left" :style="{
      display: this.$store.state.HasChildrenDepartment ? 'block' : 'none',
    }"> -->
    <section class="dp-left">
      <DepartmentPane directory-scope="school" @tree-node-click="treeNodeClick" :type="1"></DepartmentPane>
    </section>

    <section class="dp-right">
      <!--工具条-->
      <toolbar :buttonList="buttonList" @callFunction="callFunction" :searchList="searchList"></toolbar>

      <!--列表-->
      <div class="tbl-scroll-host">
      <el-table :data="users" v-loading="listLoading" @select="dialogCheck" @row-click="selectCurrentRow" ref="table"
        class="custom-tbl" height="100%" style="width: 100%">
        <el-table-column type="selection" width="50"> </el-table-column>
        <el-table-column prop="Name" label="名称" width="">
        </el-table-column>
        <el-table-column prop="DepartmentName" label="部门" :formatter="formatDepartmentNameCol" width="">
        </el-table-column>
        <el-table-column prop="Type" label="类型" width="">
          <template slot-scope="scope">
            <el-tag>{{ scope.row.Type === 'weekly' ? '周模式' : '假期模式' }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="OnTime" label="开机时间" width="">
        </el-table-column>
        <el-table-column prop="OffTime" label="关机时间" width="">
        </el-table-column>
        <el-table-column prop="Weekdays" label="周次" width="">
          <template slot-scope="scope">
            <div v-if="scope.row.Type === 'weekly'">
              <span v-for="(day, index) in formatWeekdays(scope.row.Weekdays)" :key="index"
                :class="day.active ? 'active-day' : 'inactive-day'">
                {{ day.name }}
              </span>
            </div>
            <span v-else></span>
          </template>
        </el-table-column>

        <!-- <el-table-column label="授权终端" width="200">
          <template slot-scope="scope">
            <template
              v-if="scope.row.AuthLog && (Array.isArray(scope.row.AuthLog) ? scope.row.AuthLog.length : (JSON.parse(scope.row.AuthLog || '[]').length)) > 0">
              <el-tag
                v-for="(item, idx) in (Array.isArray(scope.row.AuthLog) ? scope.row.AuthLog : JSON.parse(scope.row.AuthLog || '[]'))"
                :key="item.TerminalId + idx" type="success" style="margin-right: 4px;">
                {{ item.TerminalId }}
              </el-tag>
            </template>
            <el-tag v-else type="info">无</el-tag>
          </template>
        </el-table-column> -->

        <el-table-column label="授权记录" width="120">
          <template slot-scope="scope">
            <el-tag
              v-if="scope.row.AuthLog && (Array.isArray(scope.row.AuthLog) ? scope.row.AuthLog.length : (JSON.parse(scope.row.AuthLog || '[]').length)) > 0"
              type="success" @click.native="showAuthLog(scope.row)" style="cursor:pointer">
              {{ Array.isArray(scope.row.AuthLog) ? scope.row.AuthLog.length :
                (JSON.parse(scope.row.AuthLog || '[]').length) }} 条
            </el-tag>
            <el-tag v-else type="info" @click.native="showAuthLog(scope.row)" style="cursor:pointer">无</el-tag>
          </template>
        </el-table-column>

      </el-table>
      </div>

      <!--编辑界面-->
      <el-dialog title="编辑定时开关机" :visible.sync="editFormVisible" v-model="editFormVisible"
        :close-on-click-modal="false">
        <el-form :model="editForm" label-width="100px" :rules="editFormRules" ref="editForm">
          <el-form-item label="名称" prop="Name">
            <el-input v-model="editForm.Name" auto-complete="off"></el-input>
          </el-form-item>
          <el-form-item label="类型" prop="Type">
            <el-radio-group v-model="editForm.Type" @change="handleTypeChange('edit')">
              <el-radio label="weekly">周模式</el-radio>
              <el-radio label="single">假期模式</el-radio>
            </el-radio-group>
          </el-form-item>

          <el-form-item label="开机时间" prop="OnTime">
            <template v-if="editForm.Type === 'weekly'">
              <el-time-select v-model="editForm.OnTime" :key="'edit_onTime_' + editForm.Type" placeholder="选择时间"
                style="width: 100%" :picker-options="{
                  start: '00:00',
                  step: '00:15',
                  end: '23:45'
                }"></el-time-select>
            </template>
            <template v-else>
              <el-date-picker v-model="editForm.OnTime" :key="'edit_onTime_' + editForm.Type" type="datetime"
                placeholder="选择日期时间" style="width: 100%" format="yyyy-MM-dd HH:mm" value-format="yyyy-MM-dd HH:mm">
              </el-date-picker>
            </template>
          </el-form-item>
          <el-form-item label="关机时间" prop="OffTime">
            <template v-if="editForm.Type === 'weekly'">
              <el-time-select v-model="editForm.OffTime" :key="'edit_offTime_' + editForm.Type" placeholder="选择时间"
                style="width: 100%" :picker-options="{
                  start: '00:00',
                  step: '00:15',
                  end: '23:45'
                }"></el-time-select>
            </template>
            <template v-else>
              <el-date-picker v-model="editForm.OffTime" :key="'edit_offTime_' + editForm.Type" type="datetime"
                placeholder="选择日期时间" style="width: 100%" format="yyyy-MM-dd HH:mm" value-format="yyyy-MM-dd HH:mm">
              </el-date-picker>
            </template>
          </el-form-item>

          <el-form-item label="周次" prop="Weekdays" v-if="editForm.Type === 'weekly'">
            <div class="weekdays-container">
              <div v-for="(day, index) in weekDays" :key="index" class="weekday-item">
                <el-checkbox v-model="day.checked" @change="updateWeekdays('edit')">
                  {{ day.name }}
                </el-checkbox>
              </div>
            </div>
          </el-form-item>

          <el-form-item label="备注" prop="Remark">
            <el-input type="textarea" v-model="editForm.Remark" auto-complete="off"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click.native="editFormVisible = false">取消</el-button>
          <el-button type="primary" @click.native="editSubmit" :loading="editLoading">提交</el-button>
        </div>
      </el-dialog>

      <!--新增界面-->
      <el-dialog title="新增定时开关机" :visible.sync="addFormVisible" v-model="addFormVisible" :close-on-click-modal="false">
        <el-form :model="addForm" label-width="100px" :rules="addFormRules" ref="addForm" class="demo-form-inline">
          <el-form-item label="名称" prop="Name">
            <el-input v-model="addForm.Name" auto-complete="off"></el-input>
          </el-form-item>
          <el-form-item label="类型" prop="Type">
            <el-radio-group v-model="addForm.Type" @change="handleTypeChange('add')">
              <el-radio label="weekly">周模式</el-radio>
              <el-radio label="single">假期模式</el-radio>
            </el-radio-group>
          </el-form-item>

          <el-form-item label="开机时间" prop="OnTime">
            <template v-if="addForm.Type === 'weekly'">
              <el-time-select v-model="addForm.OnTime" :key="'onTime_' + addForm.Type" placeholder="选择时间"
                style="width: 100%" :picker-options="{
                  start: '00:00',
                  step: '00:15',
                  end: '23:45'
                }"></el-time-select>
            </template>
            <template v-else>
              <el-date-picker v-model="addForm.OnTime" :key="'onTime_' + addForm.Type" type="datetime"
                placeholder="选择日期时间" style="width: 100%" format="yyyy-MM-dd HH:mm" value-format="yyyy-MM-dd HH:mm">
              </el-date-picker>
            </template>
          </el-form-item>
          <el-form-item label="关机时间" prop="OffTime">
            <template v-if="addForm.Type === 'weekly'">
              <el-time-select v-model="addForm.OffTime" :key="'offTime_' + addForm.Type" placeholder="选择时间"
                style="width: 100%" :picker-options="{
                  start: '00:00',
                  step: '00:15',
                  end: '23:45'
                }"></el-time-select>
            </template>
            <template v-else>
              <el-date-picker v-model="addForm.OffTime" :key="'offTime_' + addForm.Type" type="datetime"
                placeholder="选择日期时间" style="width: 100%" format="yyyy-MM-dd HH:mm" value-format="yyyy-MM-dd HH:mm">
              </el-date-picker>
            </template>
          </el-form-item>

          <el-form-item label="周次" prop="Weekdays" v-if="addForm.Type === 'weekly'">
            <div class="weekdays-container">
              <div v-for="(day, index) in addWeekDays" :key="index" class="weekday-item">
                <el-checkbox v-model="day.checked" @change="updateWeekdays('add')">
                  {{ day.name }}
                </el-checkbox>
              </div>
            </div>
          </el-form-item>

          <el-form-item label="备注" prop="Remark">
            <el-input type="textarea" v-model="addForm.Remark" auto-complete="off"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click.native="addFormVisible = false">取消</el-button>
          <el-button type="primary" @click.native="addSubmit" :loading="addLoading">提交</el-button>
        </div>
      </el-dialog>

      <!-- 应用终端对话框 -->
      <el-dialog :title="'【' + this.title + '】授权记录'" :visible.sync="authLogDialogVisible" width="720px"
        custom-class="power-auth-log-dialog">
        <div class="auth-log-toolbar">
          <el-select v-model="selectedTerminalId" placeholder="请选择班牌" filterable clearable
            class="auth-log-toolbar__select">
            <el-option v-for="item in terminalSelectList" :key="item.TerminalId"
              :label="`${item.TerminalId} - ${item.TerminalName}${item.AuthDeptName ? '（已绑定：' + item.AuthDeptName + '）' : ''}`"
              :value="item.TerminalId" />
          </el-select>
          <div class="auth-log-toolbar__actions">
            <el-button type="primary" @click="handleManualAuth">手动授权</el-button>
            <el-button type="success" @click="handleAuthAll">授权全部</el-button>
          </div>
        </div>
        <el-table :data="paginatedAuthLogList" style="width: 100%;" max-height="360">
          <el-table-column prop="TerminalId" label="终端编号" min-width="120"></el-table-column>
          <el-table-column prop="TerminalName" label="终端名称" min-width="120" show-overflow-tooltip></el-table-column>
          <el-table-column prop="Remarks" label="安装位置" min-width="120" show-overflow-tooltip></el-table-column>
          <el-table-column prop="AuthTime" label="授权时间" min-width="160"></el-table-column>
          <el-table-column label="操作" width="80" align="center" fixed="right">
            <template slot-scope="scope">
              <el-button type="danger" size="mini" @click="handleUnbindTerminal(scope.row)">解绑</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="auth-log-pager">
          <el-pagination @current-change="handleAuthLogPageChange" @size-change="handleAuthLogSizeChange"
            :current-page="authLogCurrentPage" :page-size="authLogPageSize" :page-sizes="[10, 20, 50]"
            :total="authLogTotal" layout="total, sizes, prev, pager, next, jumper"></el-pagination>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button @click="authLogDialogVisible = false">关闭</el-button>
        </div>
      </el-dialog>

    </section>

  </section>

</template>

<script>
import util from "../../../util/date";
import { testapi } from '../../api/modules/auth';
import { getPowerOnOffScheduleListPage, editPowerOnOffSchedule, addPowerOnOffSchedule, deletePowerOnOffSchedule } from '../../api/modules/dormitory';
import { getTeachingDepartmentTree, unbindTerminalPowerOnOff, manualAuthorizeTerminalPowerOnOff } from '../../api/modules/department';
import { BaseApiUrl } from '../../api/base';
import { getCplateTerminalListPage, batchAuthorizeTerminals } from '../../api/modules/attendance';
import { getButtonList } from "../../promissionRouter";
import Toolbar from "../../components/Toolbar";
import DepartmentPane from '../../components/DepartmentPane'
import es from "@/lang/es";

export default {
  components: { Toolbar, DepartmentPane },
  data() {
    return {
      filters: {
      },
      BaseApiUrl: BaseApiUrl, //网络前缀
      searchList: [
        {
          label: '名称',
          key: 'name',
        },
      ],
      users: [],
      roles: [],
      options: [],
      total: 0,
      buttonList: [],
      currentRow: null,
      page: 1,
      listLoading: false,
      sels: [], //列表选中列
      liveTypeList: [],
      liveTypeId: "",
      addDialogFormVisible: false,
      editFormVisible: false, //编辑界面是否显示
      editLoading: false,
      editFormRules: {
        Name: [{ required: true, message: "请输入名称", trigger: "blur" }],
        Type: [{ required: true, message: "请选择类型", trigger: "change" }],
        OnTime: [{ required: true, message: "请选择开机时间", trigger: "change" }],
        OffTime: [{ required: true, message: "请选择关机时间", trigger: "change" }],
        Weekdays: [
          { required: true, message: '请选择重复日期', trigger: 'change' }
        ]
      },
      //编辑界面数据
      editForm: {
        Id: 0,
        Name: '',
        Type: 'weekly',
        OnTime: '',
        OffTime: '',
        Weekdays: '',
        Remark: '',
        DepartmentId: 0,
      },
      isResouceShow: 0,
      weekDays: [
        { name: '周一', checked: false, index: 0 },
        { name: '周二', checked: false, index: 1 },
        { name: '周三', checked: false, index: 2 },
        { name: '周四', checked: false, index: 3 },
        { name: '周五', checked: false, index: 4 },
        { name: '周六', checked: false, index: 5 },
        { name: '周日', checked: false, index: 6 }
      ],
      addFormVisible: false, //新增界面是否显示
      addLoading: false,
      addFormRules: {
        Name: [{ required: true, message: "请输入名称", trigger: "blur" }],
        Type: [{ required: true, message: "请选择类型", trigger: "change" }],
        OnTime: [{ required: true, message: "请选择开机时间", trigger: "change" }],
        OffTime: [{ required: true, message: "请选择关机时间", trigger: "change" }],
        Weekdays: [
          { required: true, message: '请选择重复日期', trigger: 'change' }
        ]
      },
      //新增界面数据
      addForm: {
        Name: '',
        Type: 'weekly',
        OnTime: '',
        OffTime: '',
        Weekdays: '',
        Remark: '',
        DepartmentId: 0
      },
      addWeekDays: [
        { name: '周一', checked: false, index: 0 },
        { name: '周二', checked: false, index: 1 },
        { name: '周三', checked: false, index: 2 },
        { name: '周四', checked: false, index: 3 },
        { name: '周五', checked: false, index: 4 },
        { name: '周六', checked: false, index: 5 },
        { name: '周日', checked: false, index: 6 }
      ],
      DepartmentId: 0,
      currentUserId: '',
      imageUrl: '',
      imageLoadding: false,

      // 应用终端相关数据
      applyTerminalVisible: false,
      applyTerminalForm: {
        terminalIds: [],
        scheduleId: ''
      },
      terminals: [], // 终端列表
      terminalLoading: false,

      currentDepartmentName: '',
      authLogDialogVisible: false,
      authLogList: [],
      // 新增分页相关变量
      authLogCurrentPage: 1,
      authLogPageSize: 10,
      authLogTotal: 0,

      terminalSelectList: [],
      selectedTerminalId: '',
      authLogId: 0, // 授权记录ID
      title: "",
    };
  },
  computed: {
    // 新增分页计算属性
    paginatedAuthLogList() {
      const start = (this.authLogCurrentPage - 1) * this.authLogPageSize;
      const end = start + this.authLogPageSize;
      return this.authLogList.slice(start, end);
    }
  },
  methods: {

    async showAuthLog(row) {
      // 假设 AuthLog 字段为 JSON 字符串或对象数组
      let log = row.AuthLog;
      this.authLogId = row.Id; // 记录当前操作的授权记录ID
      this.title = this.currentDepartmentName + "--" + row.Name; // 设置标题
      if (typeof log === 'string') {
        try {
          this.authLogList = JSON.parse(log);
        } catch {
          this.authLogList = [];
        }
      } else if (Array.isArray(log)) {
        this.authLogList = log;
      } else {
        this.authLogList = [];
      }

      // 新增：设置分页总数并重置当前页
      this.authLogTotal = this.authLogList.length;
      this.authLogCurrentPage = 1;
      this.authLogDialogVisible = true;

      // 查询班牌列表
      const res = await getCplateTerminalListPage({
        departmentId: this.DepartmentId,
        page: 1,
        intPageSize: 1000 // 可根据实际情况调整,
      });

      this.terminalSelectList = res.data.response.data || [];

      this.selectedTerminalId = '';

    },

    // 解绑终端
    handleUnbindTerminal(row) {
      this.$confirm('确定要解绑该终端吗？', '提示', { type: 'warning' }).then(() => {
        unbindTerminalPowerOnOff({
          TerminalId: row.TerminalId,
          ClassAuthId: this.authLogId,
        }).then(res => {
          if (res.data && res.data.success) {
            this.$message.success('解绑成功');
            this.authLogDialogVisible = false;
            // 重新加载授权记录
            this.handleQuery();
          } else {
            this.$message.error(res.data && res.data.msg ? res.data.msg : '解绑失败');
          }
        });
      });
    },

    // 手动授权
    async handleManualAuth() {
      if (!this.selectedTerminalId) {
        this.$message.warning('请选择班牌');
        return;
      }
      this.$confirm('确定要授权？', '提示', { type: 'warning' })
        .then(() => {
          this.doManualAuth();
        })
        .catch(() => { });
    },

    // 新增：授权所有班牌方法
    handleAuthAll() {
      this.$confirm('确定要授权所有班牌吗？', '提示', { type: 'warning' })
        .then(() => {
          this.doAuthAll();
        })
        .catch(() => { });
    },

    // 新增分页页码变更处理方法
    handleAuthLogPageChange(page) {
      this.authLogCurrentPage = page;
    },
    handleAuthLogSizeChange(size) {
      this.authLogPageSize = size;
      this.authLogCurrentPage = 1;
    },

    // 新增：实际执行授权所有班牌逻辑
    async doAuthAll() {
      try {
        const res = await batchAuthorizeTerminals({
          TerminalId: -1,
          ClassAuthId: this.authLogId,
        });
        if (res.data && res.data.success) {
          this.$message.success('批量授权成功');
          this.authLogDialogVisible = false;
          // 重新加载授权记录
          this.handleQuery();
        } else {
          this.$message.error(res.data && res.data.msg ? res.data.msg : '批量授权失败');
        }
      } catch (e) {
        this.$message.error('批量授权失败');
      }
    },

    // 新增实际授权方法
    async doManualAuth() {
      try {
        const res = await manualAuthorizeTerminalPowerOnOff({
          TerminalId: this.selectedTerminalId,
          ClassAuthId: this.authLogId,
        });
        if (res.data && res.data.success) {
          this.$message.success('授权成功');
          this.authLogDialogVisible = false;
          // 重新加载授权记录
          this.handleQuery();
        } else {
          this.$message.error(res.data && res.data.msg ? res.data.msg : '授权失败');
        }
      } catch (e) {
        this.$message.error('授权失败');
      }
    },

    handleTypeChange(formType) {
      const form = formType === 'edit' ? this.editForm : this.addForm;
      // 重置时间格式
      if (form.Type === 'weekly') {
        // 周模式下只保留时间部分
        if (form.OnTime && form.OnTime.length > 5) {
          form.OnTime = form.OnTime.slice(11);
        }
        if (form.OffTime && form.OffTime.length > 5) {
          form.OffTime = form.OffTime.slice(11);
        }
      } else {
        // 单次模式下补充当前日期
        const now = new Date();
        const dateStr = now.getFullYear() + '-' +
          (now.getMonth() + 1).toString().padStart(2, '0') + '-' +
          now.getDate().toString().padStart(2, '0');

        if (form.OnTime && form.OnTime.length === 5) {
          form.OnTime = dateStr + ' ' + form.OnTime;
        }
        if (form.OffTime && form.OffTime.length === 5) {
          form.OffTime = dateStr + ' ' + form.OffTime;
        }
      }
    },

    updateWeekdays(formType) {
      const weekdays = formType === 'edit' ? this.weekDays : this.addWeekDays;
      const form = formType === 'edit' ? this.editForm : this.addForm;

      // 将选中状态转换为字符串格式 "1|1|1|1|1|0|0"
      form.Weekdays = weekdays.map(day => day.checked ? '1' : '0').join('|');
    },

    formatWeekdays(weekdaysStr) {
      if (!weekdaysStr) return [];

      const weekdaysArr = weekdaysStr.split('|');
      return this.weekDays.map((day, index) => ({
        name: day.name,
        active: weekdaysArr[index] === '1'
      }));
    },

    treeNodeClick(data, node, component) {
      this.DepartmentId = data.value
      this.currentDepartmentName = data.label || data.name || ''
      this.handleQuery();
    },

    dialogCheck(selection, row) {
      this.currentRow = null;
      this.$refs.table.clearSelection();
      if (selection.length === 0) {
        return;
      }
      if (row) {
        this.selectCurrentRow(row);
      }
    },
    selectCurrentRow(val) {
      if (val) {
        this.currentRow = val;
        this.$refs.table.clearSelection();
        this.$refs.table.toggleRowSelection(val, true);
      }
    },
    callFunction(item) {
      if (typeof item.search == 'object') {
        this.filters = item.search
      } else {
        this.filters = {
          key: item.search,
        }
      }
      this[item.Func].apply(this, item)
    },

    handleCurrentChange(val) {
      this.page = val;
      this.handleQuery();
    },

    //获取用户列表
    handleQuery() {
      let para = {
        departmentId: this.DepartmentId,
        ...this.filters,
      }
      this.listLoading = true;
      testapi();
      getPowerOnOffScheduleListPage(para).then((res) => {
        this.total = res.data.response.dataCount
        this.PageSize = res.data.response.PageSize
        this.users = res.data.response.data
        this.listLoading = false
      });
    },
    //显示编辑界面
    handleEdit() {
      let row = this.currentRow;
      this.options = [];
      if (!row) {
        this.$message({
          message: "请选择要编辑的一行数据！",
          type: "error",
        });
        return;
      }

      // 重置星期选择
      this.weekDays.forEach(day => day.checked = false);

      // 填充表单数据
      this.editForm = Object.assign({}, row);

      // 处理星期数据
      if (row.Weekdays) {
        const weekdaysArr = row.Weekdays.split('|');
        this.weekDays.forEach((day, index) => {
          day.checked = weekdaysArr[index] === '1';
        });
      }

      this.editFormVisible = true;
    },
    //编辑
    editSubmit: function () {
      this.$refs.editForm.validate((valid) => {
        if (valid) {
          this.$confirm("确认提交吗？", "提示", {}).then(() => {
            this.editLoading = true;

            let para = Object.assign({}, this.editForm);

            editPowerOnOffSchedule(para).then((res) => {
              if (util.isEmt.format(res)) {
                this.editLoading = false;
                return;
              }
              if (res.data.success) {
                this.editLoading = false;
                this.$message({
                  message: res.data.msg,
                  type: "success",
                });
                this.$refs["editForm"].resetFields();
                this.options = [];
                this.editFormVisible = false;
                this.handleQuery();
              } else {
                this.$message({
                  message: res.data.msg,
                  type: "error",
                });
                this.editLoading = false;
              }
            });
          });
        }
      });
    },
    //删除
    handleDel() {
      let row = this.currentRow;
      this.options = [];
      if (!row) {
        this.$message({
          message: "请选择要编辑的一行数据！",
          type: "error",
        });
        return;
      }
      this.$confirm("确认删除该记录吗?", "提示", {
        type: "warning",
      })
        .then(() => {
          this.listLoading = true;
          //NProgress.start();
          let para = { id: row.Id };
          deletePowerOnOffSchedule(para).then((res) => {
            if (util.isEmt.format(res)) {
              this.listLoading = false;
              return;
            }
            this.listLoading = false;
            //NProgress.done();
            if (res.data.success) {
              this.$message({
                message: "删除成功",
                type: "success",
              });
            } else {
              this.$message({
                message: res.data.msg,
                type: "error",
              });
            }

            this.handleQuery();
          });
        })
        .catch(() => { });
    },
    // 显示新增界面
    handleAdd() {
      if (!this.DepartmentId || this.DepartmentId === 0) {
        this.$message({ message: '请先选择左侧所属机构！', type: 'warning' });
        return;
      }
      this.addFormVisible = true;

      // 重置表单数据
      this.addForm = {
        Name: '',
        Type: 'weekly',
        OnTime: '',
        OffTime: '',
        Weekdays: '',
        Remark: '',
        DepartmentId: this.DepartmentId
      };

      // 重置星期选择
      this.addWeekDays.forEach(day => day.checked = false);
    },
    // 新增提交
    addSubmit: function () {
      this.$refs.addForm.validate((valid) => {
        if (valid) {
          this.$confirm("确认提交吗？", "提示", {}).then(() => {
            this.addLoading = true;

            let para = Object.assign({}, this.addForm);

            addPowerOnOffSchedule(para).then((res) => {
              if (util.isEmt.format(res)) {
                this.addLoading = false;
                return;
              }
              if (res.data.success) {
                this.addLoading = false;
                this.$message({
                  message: res.data.msg,
                  type: "success",
                });
                this.$refs["addForm"].resetFields();
                this.options = [];
                this.addFormVisible = false;
                this.handleQuery();
              } else {
                this.$message({
                  message: res.data.msg,
                  type: "error",
                });
                this.addLoading = false;
              }
            });
          });
        }
      });
    },
    // 格式化部门名称：只保留路径的最后两级
    formatDepartmentNameCol(row, column, cellValue) {
      if (!cellValue) return '';
      const parts = cellValue.split('/');
      if (parts.length > 2) {
        return parts.slice(-2).join('/');
      }
      return cellValue;
    },
  },
  mounted() {

    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : [];
    this.buttonList = getButtonList(this.$route.path, routers);
  },
};
</script>

<style scoped>
.custom-tbl /deep/ .has-gutter .el-checkbox {
  display: none;
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: var(--btn-primary, #2563eb);
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 106.8px;
  height: 106.8px;
  line-height: 106.8px;
  text-align: center;
}

.avatar {
  width: 106.8px;
  height: 106.8px;
  display: block;
}

.avatar-uploader-tip {
  position: absolute;
  width: 100%;
  height: 1vw;
  bottom: 20px;
  color: gray;
  z-index: 99;
}

.weekdays-container {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.weekday-item {
  display: flex;
  align-items: center;
  margin-right: 15px;
  margin-bottom: 10px;
}

.active-day {
  display: inline-block;
  width: 36px;
  height: 36px;
  line-height: 36px;
  text-align: center;
  border-radius: 50%;
  background-color: var(--btn-primary, #2563eb);
  color: white;
  margin-right: 5px;
}

.inactive-day {
  display: inline-block;
  width: 36px;
  height: 36px;
  line-height: 36px;
  text-align: center;
  border-radius: 50%;
  background-color: #e9e9e9;
  color: #606266;
  margin-right: 5px;
}
</style>

<!-- 授权弹窗挂到 body，需全局样式覆盖 dialog 内 el-select 默认 block -->
<style>
.power-auth-log-dialog .auth-log-toolbar {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px 12px;
  margin-bottom: 12px;
}

.power-auth-log-dialog .auth-log-toolbar__select {
  flex: 1 1 320px;
  min-width: 220px;
  width: auto !important;
  max-width: none;
}

.power-auth-log-dialog .auth-log-toolbar__select.el-select {
  display: block;
}

.power-auth-log-dialog .auth-log-toolbar__select .el-input {
  width: 100%;
}

.power-auth-log-dialog .auth-log-toolbar__actions {
  display: flex !important;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
  flex-shrink: 0;
}

.power-auth-log-dialog .auth-log-toolbar__actions .el-button {
  margin-left: 0 !important;
}

.power-auth-log-dialog .auth-log-toolbar__actions .el-button + .el-button {
  margin-left: 10px !important;
}

.power-auth-log-dialog .auth-log-pager {
  margin-top: 12px;
  width: 100%;
  display: flex;
  justify-content: flex-end;
}

.power-auth-log-dialog .auth-log-pager .el-pagination {
  display: flex !important;
  flex-wrap: wrap;
  justify-content: flex-end !important;
  align-items: center;
  width: 100%;
  float: none !important;
  padding: 0;
  margin: 0;
  row-gap: 6px;
}
</style>
